export default {

	appVersion: process.env.VUE_APP_VERSION,

	// Local variables
	user: {
		isController: false,
		name: "",
		isAdmin: false,
        key:null
	},

	controllerKey: null,
	showControllerHint: false,
	showControllerPage: false,
	showVolumeControls: false,
	hintText: null,
	countdownTarget: null,
	countdown: 1000 * 60 * 10,
	countdownTimer: null,

	// Remote database connections
	sessionRef: null,

	// None changing data
	session: {
		passcode: null,
		operatorCode: null,
		id: null,
		axis: 0,
		isLocked: false,
		roomUrl: null,
		hostRoomUrl: null
	},

	scenario: {
		name: null,
		adversaryTask: null,
		advocateTask: null,
		adversaryRoles: [],
		advocateRoles: [],
		adversaryHints: [],
		advocateHints: [],
		adversaryTactics: [],
		advocateTactics: [],
		video: []
	},

	videoDownloadURLs: {},




	//
	// FIREBASE REAL-TIME VARIABLES
	//
	// Status variables for connecting and saving etc
	connectionStatus: {
		type: "",
		message: ""
	},
	requestingHelp: false,
	requestingHelpHint: false,
	pageName: '',
	roleActiveTab: "archetypes",
	strategyActiveTab: "objectives",
	confirmActiveTab: "confirm",
	feedbackActiveTab: 1,
	side: "",
	difficulty: "",
	visionText: "",
	motivationText: "",
	impactText: "",
	methodText: "",
	targetText: "",
	objectiveText: "",
	tacticText: "",
	archetypeOtherText: "",
	selectedArchetype: {
		index: -1,
		title: '',
		text: ""
	},
	roleOtherText: "",
	selectedRole: {
		index: -1,
		title: '',
		text: ""
	},
	feedback: ["", "", "", "", ""],
	usersObj: {},
}
